import { Typography } from "@mui/material"
import sadAvatar from "../../../assets/images/SadAvatar.svg"

const SadAvatar = ({label,alt})=>{
    return <><Typography variant="title">{label}</Typography><img style={{ height: "50%" }} src={sadAvatar} alt={alt}></img> </>
}

export default SadAvatar

